import {Suspense, useEffect, useState} from 'react'
import LivePlayer from '@/components/LivePlayer'

import './page.css'

import dynamic from 'next/dynamic'
import {useParams} from 'next/navigation'
import {getBlockStreamerInfo} from '@/services/userBlock'
import {useTranslations} from 'next-intl'

import BlockStreamer from '../BlockStreamer'

const ChatBox = dynamic(() => import('@/components/ChatBox'))
const Header = dynamic(() => import('@/components/Header'))
const Layer = dynamic(() => import('@/components/Layer'))
const RankingButton = dynamic(() => import('@/components/RankingButton'))
const RecommendationList = dynamic(
  () => import('@/components/RecommendationList'),
)

type IframePlayerProps = {
  type?: string
  broadNo?: string
  isIframe?: boolean
}
export default function PlayerPage({
  type,
  broadNo,
  isIframe,
}: IframePlayerProps) {
  const t = useTranslations()
  const params = useParams<{bjId: string}>()

  const bjId = params.bjId as string
  const [isBlocked, setIsBlocked] = useState(false)
  const [data, setData] = useState()

  useEffect(() => {
    const fetchBlockStreamerInfo = async () => {
      try {
        const res = await getBlockStreamerInfo(bjId)
        if (res?.response.status === 515) {
          setIsBlocked(true)
          setData(res)
        } else {
          setIsBlocked(false)
        }
      } catch (error) {
        setIsBlocked(false)
      }
    }
    fetchBlockStreamerInfo()
  }, [bjId])

  if (isBlocked) {
    return <BlockStreamer dataBlock={data} />
  }

  return (
    <div
      id="webplayer"
      chat-move="true"
      className={'webplayer_live chat_open layout_v2 list_open'}
    >
      <div
        id="webplayer_top"
        className={'u211007' + (isIframe ? ' hideHeader' : '')}
      >
        <Header />
      </div>
      <div
        id="webplayer_scroll"
        className={isIframe ? ' isIframeContainer' : ''}
      >
        <div
          id="webplayer_contents"
          className={type == 'direct' ? ' showChatIframe ' : ' normalIframe'}
        >
          <div id="player_area">
            <div className="htmlplayer_wrap">
              <div className="htmlplayer_content">
                <LivePlayer nBroadNo={broadNo} />
                <div className="player_item_list on preroll">
                  <div className="text_output">
                    <p></p>
                  </div>
                  <ul>
                    <li className="multi" style={{display: 'none'}}>
                      <button type="button">
                        <em></em>
                        <span>{t('multi')}</span>
                      </button>
                      <div className="sub_tooltip">{t('multi')}</div>
                    </li>
                    <li className="vr" style={{display: 'none'}}>
                      <button type="button">
                        <em></em>
                        <span>{t('start-vr')}</span>
                      </button>
                      <div className="sub_tooltip">{t('start-vr')}</div>
                    </li>
                    <li className="count_vote" style={{display: 'none'}}>
                      <button type="button">
                        <em></em>
                        <span>{t('vote-count')}</span>
                      </button>
                      <div className="sub_tooltip">{t('vote-count')}</div>
                    </li>
                    <li className="vote_result" style={{display: 'none'}}>
                      <button type="button">
                        <em></em>
                        <span>{t('vote-result')}</span>
                      </button>
                      <div className="sub_tooltip">{t('vote-result')}</div>
                    </li>
                    <li className="vote" style={{display: 'none'}}>
                      <button type="button">
                        <em></em>
                        <span>{t('vote')}</span>
                      </button>
                      <div className="sub_tooltip">{t('vote')}</div>
                    </li>
                    <li className="user_join" style={{display: 'none'}}>
                      <button id="u_multi" type="button">
                        <em></em>
                        <span>{t('su-tham-gia-cua-nguoi-dung')}</span>
                      </button>
                      <div className="sub_tooltip">
                        {t('phat-song-tham-gia-cua-nguoi-dung')}
                      </div>
                      <div
                        className="item_list_layer"
                        style={{display: 'none'}}
                      >
                        <strong>
                          {t('nguoi-dung-su-tham-gia-loi-yeu-cau')}
                        </strong>
                        <p>{t('giua-khong-trung-tham-gia-nhin')}</p>
                        <a href="#" className="close">
                          {t('dong')}
                        </a>
                      </div>
                    </li>
                    <RankingButton />
                    {/* <li className="rankings">
                      <button type="button">
                        <em></em>
                        <span>{t('rankings')}</span>
                      </button>
                      <div className="sub_tooltip">{t('rankings')}</div>
                    </li> */}
                    <li
                      className="subscribe"
                      style={{
                        verticalAlign: 'bottom',
                      }}
                    >
                      <button type="button">
                        <em></em>
                        <span>{t('subscription')}</span>
                      </button>
                      <div className="sub_tooltip">{t('subscription')}</div>
                    </li>

                    <li className="star_balloon">
                      <button type="button">
                        <em></em>
                        <span>{t('star-balloons')}</span>
                      </button>
                      <div className="sub_tooltip">{t('star-balloons')}</div>
                      <div className="speech_bubble" style={{display: 'none'}}>
                        <strong>{t('gio-ket-thuc')}</strong>
                        <p>
                          {t(
                            'trong-doi-chien-thang-bong-bay-hay-thu-mot-mon-qua',
                          )}
                        </p>
                        <a href="#n" className="close">
                          <span>{t('lop-dong')}</span>
                        </a>
                      </div>
                    </li>
                    <li className="adballoon" style={{display: 'none'}}>
                      <button type="button" id="btnGiftAdBalloon">
                        <em></em>
                        <span>{t('qua-bong-quang-cao')}</span>
                      </button>
                      <div className="sub_tooltip">
                        {t('qua-bong-quang-cao')}
                      </div>
                      <div className="speech_bubble" style={{display: 'none'}}>
                        <em className="icon"></em>
                        <p>
                          Hiện nay băng hình quảng cáo báo cáo <br />
                          {t('qua-bong-quang-cao-qua')}
                        </p>
                        <a href="#n" className="close">
                          <span>{t('lop-dong')}</span>
                        </a>
                      </div>
                    </li>
                    <li className="shopping" style={{display: 'none'}}>
                      <button type="button">
                        <em></em>
                        <span>{t('cua-hang-prica')}</span>
                        <span className="ic_new">{t('new')}</span>
                      </button>
                      <div className="sub_tooltip">{t('cua-hang-prica')}</div>
                      <div className="adshop_layer" style={{display: 'none'}}>
                        <em className="ic_adshop"></em>
                        <strong>
                          {t('qua-bong-quang-cao-nhung-loi-ich-them-cua-hang')}
                        </strong>
                        <p>
                          Trong cửa hàng BJcủa Sản phẩm tùy chọn, Sản phẩm chung
                          <br />
                          {t('khi-mua-qua-bong-quang-cao-nhung-loi-ich-them')}
                        </p>
                        <a href="#n" className="close">
                          đóng
                        </a>
                      </div>
                    </li>
                    <li className="sticker">
                      <button type="button">
                        <em></em>
                        <span>{t('sticker')}</span>
                      </button>
                      <div className="sub_tooltip">{t('sticker')}</div>
                    </li>
                    <li className="edit_angle" style={{display: 'none'}}>
                      <button data-target="edit_angle" type="button">
                        <em></em>
                        <span>{t('go-edit')}</span>
                      </button>
                      <div className="sub_tooltip">{t('go-edit')}</div>
                    </li>
                    <li className="user_clip">
                      <button type="button">
                        <em></em>
                        <span>{t('tao-clip')}</span>
                      </button>
                      <div className="sub_tooltip">{t('tao-clip')}</div>
                    </li>
                    <li className="laterwatch">
                      <button data-target="laterwatch_text" type="button">
                        <em></em>
                        <span>{t('watch-later')}</span>
                      </button>
                      <div className="sub_tooltip">{t('watch-later')}</div>
                    </li>
                    <li className="bookmark">
                      <button data-target="bookmark_text" type="button">
                        <em></em>
                        <span>{t('favorites')}</span>
                      </button>
                      <div className="sub_tooltip">{t('favorites')}</div>
                    </li>
                    <li className="up_recommend">
                      <button data-target="up_text" type="button">
                        <em></em>
                        <span>{t('up')}</span>
                      </button>
                      <div className="sub_tooltip">Cổ vũ</div>
                    </li>
                    <li className="share">
                      <button type="button">
                        <em></em>
                        <span>{t('share')}</span>
                      </button>
                      <div className="sub_tooltip">{t('share')}</div>
                    </li>
                  </ul>

                  <div className="layer_tooltip">
                    <p className="error_text" style={{display: 'none'}}>
                      <em></em>Please favor other streamers!
                    </p>
                    <p className="up_text" style={{display: 'none'}}>
                      <em></em>You have UPed <span>{t('nickname')}</span>.<br />
                      {t('you-can-only-up-a-streamer-per-day')}
                    </p>
                    <p className="bookmark_text" style={{display: 'none'}}></p>
                    <p
                      className="laterwatch_text"
                      style={{display: 'none'}}
                    ></p>
                    <p
                      className="edit_angle_text"
                      style={{display: 'none'}}
                    ></p>
                    <p
                      className="time_shift_text alert_text"
                      style={{display: 'none'}}
                    >
                      <em></em>This is the official stream where you can use
                      <br />
                      {t(
                        'the-live-rewind-function-while-using-quickviewquickview-plus',
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="broadcast_information">
              <input type="hidden" id="szBjId" value="<?=$szBjId;?>" />
              <input type="hidden" id="nStationNo" value="<?=$nStationNo;?>" />
              <div className="bj_thumbnail">
                <a
                  href="<?=BJ_AFREECATV?>/<?=$szBjId;?>"
                  target="_blank"
                  title="Go to Blog"
                >
                  <img
                    src="https://res.onlive.vn/images/afmain/img_thumb_profile.gif"
                    // onerror="this.src='https://res.onlive.vn/images/afmain/img_thumb_profile.gif'"
                    alt="Streamer Logo"
                    className="thum"
                  />
                  <p>
                    <span>
                      Go to
                      <br />
                      {t('blog')}
                    </span>
                  </p>
                </a>
              </div>
              <div
                className="text_information"
                style={{background: 'transparent'}}
              >
                <div className="broadcast_title">
                  <div className="btn_shopping" style={{display: 'none'}}>
                    <a href="#n">{t('product-purchase')}</a>
                    <div className="layer_shopping">
                      <div>
                        Proceeds from sales are shared with <br />
                        <em className="nick"></em> who are on the air.
                      </div>
                      <button className="close">{t('close')}</button>
                      <span className="arr"></span>
                    </div>
                  </div>
                  <span>{t('szbroadtitle')}</span>
                </div>
                <div className="nickname">{t('sznickname')}</div>
                <div className="broadcast_viewer_cnt">
                  <span>
                    <em id="nAllViewer">0</em>
                  </span>
                  <div className="viewer_cnt_detail">
                    <strong>{t('current-viewers')}</strong>
                    <ul>
                      <li>
                        <i></i>
                        <span>{t('main')}</span>:
                        <span id="nCurrentViewer">0</span>(
                        <div>
                          <i></i>
                          <span>{t('pc')}</span>:<span id="nPcViewer">0</span>
                        </div>
                        /
                        <div>
                          <i></i>
                          <span>{t('mobile')}</span>:
                          <span id="nMobileViewer">0</span>
                        </div>
                        )
                      </li>
                      <li>
                        <i></i>
                        <span>{t('relay')}</span>:
                        <span id="nRelayViewer">0</span>
                      </li>
                      <li>
                        <i></i>
                        <span>{t('total-views')}</span>:
                        <span id="nTotalViewer">0</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="btn_bjaward_poll" style={{display: 'none'}}>
                  <button type="button" className="btn_bjpoll">
                    {t('bjmuc-tieu-bo-phieu')}
                  </button>
                </div>
                <div className="hashtag" id="hashtag"></div>
                <div className="etc">
                  <div className="count_cnt">
                    <div className="up_cnt">
                      <em></em>
                      <span className="count">0</span>
                    </div>
                    <div className="boomark_cnt">
                      <em></em>
                      <span className="count">0</span>
                    </div>
                  </div>
                  <ul>
                    {/* <li className="up_cnt">
                      <em>{t('up')}</em>
                      <span className="count">0</span>
                    </li>
                    <li className="boomark_cnt">
                      <em>{t('favorites')}</em>
                      <span className="count">0</span>
                    </li> */}
                    <li className="detail">
                      <button className="on">
                        <span>{t('thong-tin-phat-song')}</span>
                      </button>
                    </li>
                  </ul>
                </div>
                <ul className="detail_view" style={{display: 'block'}}>
                  <li>
                    <strong>{t('thoi-gian-bat-dau')}</strong>
                    <span>{t('szbroadstartdate')}</span>
                  </li>
                  <li>
                    <strong>{t('do-phan-giai')}</strong>
                    <span>{t('szbroadresolution')}</span>
                  </li>
                  <li>
                    <strong>{t('chat-luong')}</strong>
                    <span>{t('szbroadbps')}</span>
                  </li>
                  <li>
                    <strong>{t('danh-muc')}</strong>
                    <span></span>
                  </li>
                  <li>
                    <strong>{t('blog')}</strong>
                    <span>
                      <a href="#" target="_blank">
                        {t('on-live')}
                      </a>
                    </span>
                  </li>
                  {/* <li
                    id="btn-report"
                    className="police off btn-report"
                    onClick={(e) => {
                      e.preventDefault()
                      window.open(
                        `https://live.onlive.vn/afreeca/report_broad.php?bj_id=${bjId}&broad_no=${broadNo}`,
                        'popup',
                        'width=600,height=600',
                      )
                    }}
                  >
                    <div className="report-link">
                      <Image
                        src={
                          process.env.NEXT_PUBLIC_PATH_DOMAIN +
                          'images/icons/report-icon.svg'
                        }
                        alt="Report"
                        width={20}
                        height={20}
                      />
                      <p>Báo cáo</p>
                    </div>
                  </li> */}
                </ul>
              </div>
              <button className="chat_open">{t('tro-chuyen')}</button>
              <button className="btn_open">{t('mo-ra')}</button>
              <Suspense fallback={<p>Loading ...</p>}>
                <RecommendationList />
              </Suspense>
            </div>
          </div>

          <ChatBox />
        </div>
      </div>

      <Suspense fallback={<p>Loading ...</p>}>
        <Layer />
      </Suspense>
      <div className="fixLayer"></div>
    </div>
  )
}
